import React from "react";
import "../PagesCss/AreasAtuacao.css";
import BotaoWhatsapp from "../../component/BotaoWhatsapp";
import CTAWhatsapp from "../../component/CTAWhatsapp";

function RevisaoJuros() {
  return (
    <section className="area-page">
      <h1>Revisão de Juros e Encargos no Crédito Rural</h1>

      <p>
        No Brasil, o crédito rural é regulado pelo Banco Central, por meio do
        Manual de Crédito Rural (MCR) do Conselho Monetário Nacional (CMN).
      </p>

      <p>
        Isso significa que as instituições financeiras precisam obedecer aos
        limites estabelecidos pelo CMN no que se refere aos índices de juros,
        multa e demais encargos relativos ao crédito rural.
      </p>

      <p>
        Contudo, quase sempre esses limites não são respeitados e as dívidas
        acabam atingindo valores muito acima do que é permitido por lei.
      </p>

      <p>
        Se você quer saber se o crédito que você tomou possui juros, multa e
        demais encargos acima do permitido, clique no botão abaixo para falar
        gratuitamente com nossos especialistas, direto no seu WhatsApp.
      </p>

      <CTAWhatsapp text="Fale com um especialista" />

      <BotaoWhatsapp />
    </section>
  );
}

export default RevisaoJuros;
